import React from "react";
import { useGoogleAuthProvider } from "../GoogleAuthProvider";

export const SignInWithGoogle = (props) => {
  const { login } = useGoogleAuthProvider();

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#f8f7f2]">
      <div className="h-[406px] max-w-[702px] bg-white rounded-lg shadow-sm border border-[#e7e6e3] flex-col justify-start items-start flex overflow-hidden">
        <div className="self-stretch p-6 justify-between items-center inline-flex">
          <div className="grow shrink basis-0 h-10 justify-start items-center gap-2 flex" />
          <div className="justify-start items-center gap-1 flex">
            <div className="w-8 h-8 bg-white rounded-full border border-[#1b1a17] flex items-center justify-center">
              <div className="text-[#1b1a17] text-base font-bold font-Inter">1</div>
            </div>
            <div className="w-8 py-4 flex-col justify-start items-start gap-2.5 inline-flex">
              <div className="self-stretch h-px border border-[#e7e6e3]" />
            </div>
            <div className="w-8 h-8 bg-white rounded-full border border-[#e7e6e3] flex items-center justify-center">
              <div className="text-[#7a7871] text-base font-bold font-Inter">2</div>
            </div>
            <div className="w-8 py-4 flex-col justify-start items-start gap-2.5 inline-flex">
              <div className="self-stretch h-px border border-[#e7e6e3]" />
            </div>
            <div className="w-8 h-8 bg-white rounded-full border border-[#e7e6e3] flex items-center justify-center">
              <div className="text-[#7a7871] text-base font-bold font-Inter">3</div>
            </div>
          </div>
          <div className="grow shrink basis-0 h-10 justify-end items-center gap-2 flex" />
        </div>
        <div className="self-stretch h-[142px] p-6 flex-col justify-start items-center gap-1.5 flex">
          <div className="self-stretch text-center text-[#0a0a08] text-2xl font-semibold font-Inter leading-loose">Connect Your Gmail</div>
          <div className="self-stretch text-center text-[#7a7871] text-base font-normal font-Inter leading-7">We use secure OAuth to access only your newsletter emails. Your privacy is our top priority!</div>
        </div>
        <div className="self-stretch p-6 justify-center items-center gap-2.5 inline-flex">
          <button onClick={login} className="w-[181px] px-4 py-2 bg-white rounded-md border border-[#e7e7e4] border-solid justify-center items-center gap-2 flex hover:bg-gray-50">
            <div className="w-4 h-4 relative">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.6453 8.18495C15.6453 7.64014 15.5986 7.11335 15.5119 6.60458H8.15918V9.56975H12.3639C12.1838 10.5408 11.6256 11.3698 10.8033 11.9013V13.8269H13.2894C14.7541 12.4688 15.6453 10.5073 15.6453 8.18495Z" fill="#4285F4"/>
                <path d="M8.15889 15.6567C10.2505 15.6567 12.0153 14.9677 13.2891 13.8269L10.803 11.9013C10.1046 12.3699 9.21343 12.6448 8.15889 12.6448C6.16554 12.6448 4.47635 11.2934 3.89558 9.46973H1.32227V11.4554C2.58902 13.9456 5.17607 15.6567 8.15889 15.6567Z" fill="#34A853"/>
                <path d="M3.89586 9.46972C3.74177 9.00115 3.65505 8.50039 3.65505 7.98362C3.65505 7.46684 3.74177 6.96608 3.89586 6.49751V4.51184H1.32255C0.780516 5.5563 0.476562 6.73471 0.476562 7.98362C0.476562 9.23252 0.780516 10.4109 1.32255 11.4554L3.89586 9.46972Z" fill="#FBBC05"/>
                <path d="M8.15889 3.32245C9.29741 3.32245 10.3186 3.72904 11.1209 4.49001L13.3225 2.28835C12.0086 1.06746 10.2438 0.310547 8.15889 0.310547C5.17607 0.310547 2.58902 2.02167 1.32227 4.51184L3.89558 6.49752C4.47635 4.67384 6.16554 3.32245 8.15889 3.32245Z" fill="#EA4335"/>
              </svg>
            </div>
            <div className="text-[#1b1a17] text-sm font-medium font-Inter leading-tight whitespace-nowrap">Log in with Google</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignInWithGoogle;
